import { useEffect } from "react";
import {
  cloneNodeTree,
  createPastedNodesFromClipboard,
} from "../utils/editorTreeUtils";

function isTypingInInput() {
  const tag = document.activeElement?.tagName;

  return (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    document.activeElement?.isContentEditable
  );
}

export default function useEditorKeyboardShortcuts({
  enabled = true,

  selectedId,
  selectedIds = [],

  clipboard = [],
  setClipboard,

  getSelectedNodes,
  onDeleteSelection,
  onClearSelection,
  onPasteNodes,
}) {
  useEffect(() => {
    function handleKeyDown(e) {
      if (!enabled) return;
      if (isTypingInInput()) return;

      const key = String(e.key || "").toLowerCase();
      const isCtrlOrMeta = e.ctrlKey || e.metaKey;

      if (e.key === "Delete" || e.key === "Backspace") {
        if (!selectedId && !selectedIds.length) return;

        e.preventDefault();
        onDeleteSelection?.();
        return;
      }

      if (e.key === "Escape") {
        e.preventDefault();
        onClearSelection?.();
        return;
      }

      if (isCtrlOrMeta && key === "c") {
        e.preventDefault();

        const selected = getSelectedNodes?.() || [];
        if (!selected.length) return;

        setClipboard?.(selected.map((node) => cloneNodeTree(node)));
        return;
      }

      if (isCtrlOrMeta && key === "v") {
        e.preventDefault();

        if (!clipboard.length) return;

        const pasted = createPastedNodesFromClipboard(clipboard, 200);
        if (!pasted.length) return;

        onPasteNodes?.(pasted);
      }
    }

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    enabled,
    selectedId,
    selectedIds,
    clipboard,
    setClipboard,
    getSelectedNodes,
    onDeleteSelection,
    onClearSelection,
    onPasteNodes,
  ]);
}